import React, { useState, useContext, useEffect, useRef, useMemo } from "react";
import { Tooltip } from "../Tooltip";
import styles from "./provenanceRecord.module.css";
import InforIcon from "../../assets/InfoCircleIcon";
import SimpleBackIcon from "../../assets/simpleBackIcon.svg";
import DatePickerModal from "../DatePicker";
import DownIcon from "../../assets/DownIcon";
import FilterIcon from "../../assets/FilterIcon";
import MetadataIcon from "../../assets/MetadataIcon";
import ColumnVisibilityToggle, { ColumnDef } from "../ColumnVisibilityToggle";
import SearchModal from "../SearchModal";
import { AuthContext } from "../../contexts/auth-context";
import { useAsyncFn } from "../../hooks/use-async-fn";
import { useParams } from "react-router-dom";
import Dropdown from "../DropdownModal";
import { capitalize, formatDateTime, formatDateTimeParts } from "../../utils";
import MetadataModal from "../MetadataModal";
import { useLocation } from "react-router-dom";
import { useBreadcrumb } from "../Breadcrumb/BreadcrumbContext";
import { useSidebar } from "../NewSideBar/SidebarContext";
import { useToast } from "../../contexts/toast-context";
import NoData from "../NoData";
import PageNotFound from "../PageNotFound";
import config from "../../config";
import DownloadButton from "../DownloadButton";
import InfoPopup from "../InfoPopup";
import LayoutContainer from "../LayoutContainer";
import SearchableDropdown from "../SearchableDropdown";
import ColHeader from "../ColHeader";
import CopyIcon from "../../assets/CopyIcon";
import {
  MdPerson,
  MdBusiness,
  MdFlashOn,
  MdNumbers,
  MdInfoOutline,
  MdCalendarToday,
} from "../../onam/icons"; // ONAM glyphs (was react-icons/md)
import { OI } from "../../onam/mark";
import { FEATURES } from "../../onam/features";

const ProvenanceRecord = () => {
  const {
    getProvenanceTrail,
    getOrgByFederationID,
    getIndexOrganizations,
    getProvenanceTrialEvents,
    getLogoFederationID,
    getFederations,
    appMetadata,
    getProvenanceTrailCSV,
    getProvenanceTrailPDF,
    getConfig,
  } = useContext(AuthContext);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const params = useParams();
  const [filter_query, setfilter_query] = useState<any>(undefined);
  const [filterQueryId, setFilterQueryId] = useState(
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    filter_query || path_queryId,
  );

  const [filterEventName, setEventName] = useState<any>(undefined);
  const [filterOrgName, setOrgName] = useState<any>(undefined);
  const [filterEventType, setFilterEventType] = useState<any>(filterEventName);
  const [filterOrg, setFilterOrg] = useState<any>(filterOrgName);
  const [filterUser, setFilterUser] = useState(undefined);
  const [filterOrgId, setFilterOrgId] = useState<any>(undefined);

  const [FilterStartDate, setFilterStartDate] = useState<any>();
  const [FilterEndDate, setFilterEndDate] = useState<any>();
  const [, setInitiatedTabVisible] = useState(false);
  let tenantObj = {};
  tenantObj = appMetadata ? Object.values(appMetadata) : [];
  const organizationId = tenantObj[0]?.organization;
  const userRole = localStorage.getItem("userRole");
  const isPlatformOrAppAdmin = [
    config.superUserRole,
    config.applicationAdminRole,
  ].includes(userRole ?? "");
  const isOrgAdmin = userRole === "organization_admin";

  var sessionFederationId = localStorage.getItem("federationkey");

  const getOrgByFederationIDFn = useAsyncFn({
    promiseFn: getOrgByFederationID,
    federationID: sessionFederationId,
  });

  const getIndexOrganizationsFn = useAsyncFn({
    deferFn: getIndexOrganizations,
  });

  const { setBreadcrumbItems } = useBreadcrumb();
  const { showToast } = useToast();
  const location = useLocation(); // Get current URL
  const searchParams = new URLSearchParams(location.search); // Parse query params
  var path_queryId = params.id;
  const filterEffectMounted = useRef(false);
  const isTabSwitching = useRef(false);
  const hasAutoSwitched = useRef(false);
  const [visiblePages, setVisiblePages] = useState([1, 2, 3]);
  const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});
  const [datePickerOpen, setDatePickerOpen] = useState(false);

  const [openUserSearchModal, setOpenUserSearchModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const [fedChanged, setFedChanged] = useState(false);
  const [openParticipantsDropdown, setOpenParticipantsDropdown] =
    useState(false);
  const [openEventTypeDropdown, setOpenEventTypeDropdown] = useState(false);
  const [filterValue, setFilterValue] = useState({});
  const [filter_start, setFilterStart] = useState<any>(undefined);
  const [filter_end, setFilterEnd] = useState<any>(undefined);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [metadataModalOpen, setMetadataModalOpen] = useState(false);
  const [selectedMetadata, setSelectedMetadata] = useState("");
  const [loading, setLoading] = useState(true);
  const META_COL_KEYS = ["meta_campaign", "meta_id_type", "meta_objective", "meta_expiry", "meta_content"] as const;
  const [hiddenCols, setHiddenCols] = useState<Set<string>>(new Set(META_COL_KEYS));
  const col = (key: string) => !hiddenCols.has(key);
  const toggleCol = (key: string, visible: boolean) => {
    setHiddenCols((prev) => {
      const next = new Set(prev);
      visible ? next.delete(key) : next.add(key);
      return next;
    });
  };
  const [filterApplied, setFilterApplied] = useState(false);
  const [sortColumn, setSortColumn] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [errorMessage, setErrorMessage] = useState("");
  const [tableData, setTableData] = useState([]);
  const [, setFederationToggled] = useState(false);
  const [paginationInProgress, setPaginationInProgress] = useState(false);
  const [showTargetTab, setShowTargetTab] = useState(false);
  const [currentFederation, setCurrentFederation] = useState({
    name: localStorage.getItem("federationname") || "",
    federation_id: sessionFederationId,
  });
  const [copiedQueryId, setCopiedQueryId] = useState<string | null>(null);
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };
  const [columnWidths, setColumnWidths] = useState({
    1: "360px",
    2: "200px",
    3: "230px",
    4: "250px",
    5: "150px",
    6: "200px",
    7: "180px",
    8: "150px",
    9: "180px",
    10: "140px",
    11: "150px",
    12: "180px",
  });
  const [, setTargetTabVisible] = useState(false);
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [shimmerVisible, setShimmerVisible] = useState(false);
  const shimmerTimerRef = useRef<ReturnType<typeof setTimeout>>();
  const resizingRef = useRef({ index: null, startX: null, startWidth: null });
  const sessionOrgId = localStorage.getItem("organizationkey");
  const fedSpecificMenuLabels = JSON.parse(
    localStorage.getItem("fedSpecificMenuLabels") || "{}",
  );

  const getTrailFn = useAsyncFn({
    deferFn: getProvenanceTrail,
    offset: 0,
    limit: rowsPerPage,
    federation_id:
      currentFederation.federation_id || localStorage.getItem("federationkey"),
    query_id: path_queryId,
    event: filterEventType,
    user_name: filterUser,
    organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
    role: userRole,
    fromOrganization: "true",
  });
  const getTrailFnForTarget = useAsyncFn({
    deferFn: getProvenanceTrail,
    offset: 0,
    limit: rowsPerPage,
    federation_id:
      currentFederation.federation_id || localStorage.getItem("federationkey"),
    query_id: path_queryId || filterQueryId,
    event: filterEventType,
    user_name: filterUser,
    organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
    role: userRole,
    fromOrganization: "false",
  });
  const ShimmerRow = () => (
    <tr className={styles.shimmerRow}>
      <td><div className={`${styles.shimmerCell} ${styles.shimmerColIcon}`} /></td>
      {col("user") && <td><div className={`${styles.shimmerCell} ${styles.shimmerColUser}`} /></td>}
      {col("organizations") && <td><div className={`${styles.shimmerCell} ${styles.shimmerColOrg}`} /></td>}
      {col("eventType") && <td><div className={`${styles.shimmerCell} ${styles.shimmerColEvent}`} /></td>}
      {col("count") && <td><div className={`${styles.shimmerCell} ${styles.shimmerColCount}`} /></td>}
      {col("metadata") && <td><div className={`${styles.shimmerCell} ${styles.shimmerColMeta}`} /></td>}
      {col("timestamp") && <td><div className={`${styles.shimmerCell} ${styles.shimmerColTimestamp}`} /></td>}
      {META_COL_KEYS.map((k) => col(k) && <td key={k}><div className={`${styles.shimmerCell} ${styles.shimmerColOrg}`} /></td>)}
    </tr>
  );

  const handleMouseDown = (e, index) => {
    e.preventDefault();

    document.body.style.userSelect = "none";
    resizingRef.current = {
      index,
      startX: e.clientX,
      startWidth: parseInt(columnWidths[index], 10),
    };
    document.body.classList.add("no-select");
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    const { index, startX, startWidth } = resizingRef.current;
    if (index !== null) {
      const deltaX = e.clientX - startX;
      let newWidth = Math.max(50, startWidth + deltaX); // minimum 50px

      setColumnWidths((prev) => ({
        ...prev,
        [index]: `${newWidth}px`,
      }));
    }
  };

  const handleMouseUp = () => {
    resizingRef.current = { index: null, startX: null, startWidth: null };
    document.body.style.userSelect = "";
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
    document.body.classList.remove("no-select");
  };

  const downloadPDF = async () => {
    try {
      const res = await getProvenanceTrailPDFFn.run({
        offset: 0,
        federation_id:
          currentFederation.federation_id ||
          localStorage.getItem("federationkey"),
        query_id: path_queryId,
        event: filterEventType,
        user_name: filterUser,
        filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
        organization_id: isPlatformOrAppAdmin
          ? undefined
          : filterOrg || sessionOrgId,
        role: userRole,
        fromOrganization: showTargetTab ? "false" : "true",
      });

      if (!res.ok) {
        let errorText;
        try {
          errorText = await res.text();
        } catch (parseErr) {
          errorText = "[Unable to read error body]";
        }
        console.error("Status:", res.status);
        console.error("Response body:", errorText);

        console.error("Status:", res.status);
        console.error("Response body:", errorText);
        console.log("Content-Type:", res.headers.get("content-type"));

        throw new Error(`Download failed with status ${res.status}`);
      }

      const blob = await res.blob();

      const formatTimestamp = () => {
        const now = new Date();
        const day = now.getDate().toString().padStart(2, "0");
        const month = now.toLocaleString("default", { month: "short" });
        const year = now.getFullYear().toString().slice(-2);
        let hours = now.getHours();
        const minutes = now.getMinutes().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${day}${month}${year}_${hours}.${minutes}${ampm}`;
      };

      const contentDisposition = res.headers.get("content-disposition");
      const timestamp = formatTimestamp();
      const safeName =
        currentFederation.name?.replace(/\s+/g, "_") || "Unknown";
      let filename = `ProvenanceRecord_${safeName}_${timestamp}.pdf`;
      if (contentDisposition?.includes("filename=")) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error downloading PDF:", err);
    }
  };

  const downloadCSV = async () => {
    try {
      const res = await getProvenanceTrailCSVFn.run({
        offset: 0,
        federation_id:
          currentFederation.federation_id ||
          localStorage.getItem("federationkey"),
        query_id: path_queryId,
        event: filterEventType,
        user_name: filterUser,
        filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
        organization_id: isPlatformOrAppAdmin
          ? undefined
          : filterOrg || sessionOrgId,
        role: userRole,
        fromOrganization: showTargetTab ? "false" : "true",
      });

      if (!res.ok) {
        let errorText;
        try {
          errorText = await res.text();
        } catch (parseErr) {
          errorText = "[Unable to read error body]";
        }
        console.error("Status:", res.status);
        console.error("Response body:", errorText);

        console.error("Status:", res.status);
        console.error("Response body:", errorText);
        console.log("Content-Type:", res.headers.get("content-type"));

        throw new Error(`Download failed with status ${res.status}`);
      }

      const blob = await res.blob();

      const formatTimestamp = () => {
        const now = new Date();
        const day = now.getDate().toString().padStart(2, "0");
        const month = now.toLocaleString("default", { month: "short" });
        const year = now.getFullYear().toString().slice(-2);
        let hours = now.getHours();
        const minutes = now.getMinutes().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${day}${month}${year}_${hours}.${minutes}${ampm}`;
      };

      const contentDisposition = res.headers.get("content-disposition");
      const timestamp = formatTimestamp();
      const safeName =
        currentFederation.name?.replace(/\s+/g, "_") || "Unknown";
      let filename = `ProvenanceRecord_${safeName}_${timestamp}.csv`;
      if (contentDisposition?.includes("filename=")) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error downloading CSV:", err);
    }
  };

  const getProvenanceEventsFn = useAsyncFn({
    deferFn: getProvenanceTrialEvents,
  });

  const getConfigFn = useAsyncFn({
    deferFn: getConfig,
  });

  useEffect(() => {
    getTrailFnForTarget
      .run({
        promiseFn: getProvenanceTrail,
        limit: rowsPerPage,
        scan_index_forward: false,
        federation_id:
          currentFederation.federation_id ||
          localStorage.getItem("federationkey"),
        filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
        organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
        target: false,
        role: userRole,
        fromOrganization: "false",
      })
      .catch((err: unknown) => {
        console.error("Failed to fetch target trail:", err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getTrailFnForTarget?.data?.activities?.length)
      setTargetTabVisible(true);
    else setTargetTabVisible(false);
  }, [getTrailFnForTarget?.data]);

  useEffect(() => {
    getProvenanceEventsFn
      .run({
        federationId: sessionFederationId,
        organizationId: localStorage.getItem("organizationkey"),
      })
      .catch((err) => {
        console.error("Handled gracefully:", err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionFederationId]);

  useEffect(() => {
    getConfigFn
      .run({ organizationId: sessionOrgId })
      .catch((err) => {
        console.error("Handled gracefully:", err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fedId = currentFederation.federation_id || sessionFederationId;
    if (!fedId) return;
    getIndexOrganizationsFn
      .run({ federation_id: fedId, organization_id: organizationId })
      .catch((err) => {
        console.error("Handled gracefully:", err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFederation.federation_id]);

  useEffect(() => {
    if (
      getIndexOrganizationsFn.error ||
      getOrgByFederationIDFn.error ||
      getProvenanceEventsFn.error
    ) {
      setFailureMessage("Something went wrong. Please try again later.");
    }
  }, [
    getIndexOrganizationsFn.error,
    getOrgByFederationIDFn.error,
    getProvenanceEventsFn.error,
  ]);

  const allOrgs =
    getIndexOrganizationsFn.data?.organizations ??
    getIndexOrganizationsFn.data?.items ??
    [];
  const ALLOWED_EVENT_VALUES = new Set(["query", "audience_generated", "audience_transferred", "marked", "engaged", "marked_engaged", "deleted"]);
  var allProvenanceEvents = getProvenanceEventsFn.data
    ? getProvenanceEventsFn.data.filter((e: any) => ALLOWED_EVENT_VALUES.has(e.value?.toLowerCase()))
    : undefined;

  const allIdentifiers: { key: string; value: string }[] =
    getConfigFn.data?.message?.canonical_identity_types ?? [];
  const identityTypeMap = new Map<string, string>(
    allIdentifiers.map(({ key, value }) => [key, value]),
  );

  const getProvenanceTrailCSVFn = useAsyncFn({
    deferFn: getProvenanceTrailCSV,
    offset: 0,
    limit: rowsPerPage,
    federation_id:
      currentFederation.federation_id || localStorage.getItem("federationkey"),
    query_id: path_queryId,
    event: filterEventType,
    user_name: filterUser,
    organization_id: filterOrg,
    role: userRole,
    start_date: FilterStartDate,
    end_date: FilterEndDate,
  });

  const getProvenanceTrailPDFFn = useAsyncFn({
    deferFn: getProvenanceTrailPDF,
    offset: 0,
    limit: rowsPerPage,
    federation_id:
      currentFederation.federation_id || localStorage.getItem("federationkey"),
    query_id: path_queryId,
    event: filterEventType,
    user_name: filterUser,
    organization_id: filterOrg,
    role: userRole,
    start_date: FilterStartDate,
    end_date: FilterEndDate,
  });
  const { mainMenuItems, setActiveSubItem, setIsSideBarMenuDisabled } =
    useSidebar();

  const PR_COLUMNS: ColumnDef[] = [
    { key: "user", label: "User | Query ID", alwaysVisible: true },
    { key: "organizations", label: "Organizations" },
    { key: "eventType", label: "Event Type" },
    { key: "count", label: "Audience Size" },
    { key: "metadata", label: "Meta Data" },
    { key: "timestamp", label: "Timestamp" },
    // Optional metadata columns (hidden by default)
    { key: "meta_campaign", label: "Cohort Name" },
    { key: "meta_id_type", label: "ID Type" },
    // { key: "meta_objective", label: "Query Objective" },
    { key: "meta_expiry", label: "Expiry" },
  ];

  const toggleRow = (index: number) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleSelectFederation = (federation) => {
    setCurrentFederation({
      federation_id: federation.federation_id,
      name: federation.name,
    });
    setFedChanged(true);
    showToast(`Viewing records for: ${federation.name}`, "info");
  };

  useEffect(() => {
    if (getTrailFn?.data === undefined) return;
    setLoading(false);
    setTableData(getTrailFn.data.activities);
    if (getTrailFn.data.total_pages) {
      setTotalPages(getTrailFn.data.total_pages);
    }
    if (getTrailFn.data.total_count != null) {
      setTotalCount(getTrailFn.data.total_count);
    }
  }, [getTrailFn?.data]);

  useEffect(() => {
    if (hasAutoSwitched.current || showTargetTab) return;
    if (getTrailFn.data === undefined) return;

    if (!getTrailFn.data?.activities?.length) {
      hasAutoSwitched.current = true;
      isTabSwitching.current = true;
      resetFilterState();
      setTimeout(() => {
        isTabSwitching.current = false;
      }, 0);
      setShowTargetTab(true);
      setFilterApplied(true);
      getTrailFnForTarget.run({
        promiseFn: getProvenanceTrail,
        limit: rowsPerPage,
        scan_index_forward: false,
        federation_id:
          currentFederation.federation_id ||
          localStorage.getItem("federationkey"),
        filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
        organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
        target: false,
        role: userRole,
        fromOrganization: "false",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getTrailFn.data]);

  useEffect(() => {
    if (getTrailFnForTarget?.data === undefined) return;
    if (showTargetTab) {
      setLoading(false);
      if (getTrailFnForTarget.data?.activities?.length) {
        setInitiatedTabVisible(true);
      }
      setTableData(getTrailFnForTarget.data.activities);
      if (getTrailFnForTarget.data.total_pages) {
        setTotalPages(getTrailFnForTarget.data.total_pages);
      }
      if (getTrailFnForTarget.data.total_count != null) {
        setTotalCount(getTrailFnForTarget.data.total_count);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getTrailFnForTarget?.data]);

  useEffect(() => {
    if (fedChanged && currentFederation && !searchParams.get("queryid")) {
      if (showTargetTab)
        getTrailFnForTarget.run({
          promiseFn: getProvenanceTrail,
          offset: 0,
          limit: rowsPerPage,
          federation_id:
            currentFederation.federation_id ||
            localStorage.getItem("federationkey"),
          query_id: path_queryId || filterQueryId,
          event: filterEventType,
          user_name: filterUser,
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          role: userRole,
          fromOrganization: "false",
          start_date: FilterStartDate,
          end_date: FilterEndDate,
        });
      else {
        getTrailFn.run({
          promiseFn: getProvenanceTrail,
          offset: 0,
          limit: rowsPerPage,
          federation_id: currentFederation?.federation_id,
          query_id: path_queryId,
          event: filterEventType,
          user_name: filterUser,
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          role: userRole,
          start_date: FilterStartDate,
          end_date: FilterEndDate,
          fromOrganization: "true",
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFederation]);

  useEffect(() => {
    const queryIdFromUrl = searchParams.get("queryid");
    if (queryIdFromUrl) {
      HandleUserOrQueryFilter(queryIdFromUrl);
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        await getTrailFn.run({
          promiseFn: getProvenanceTrail,
          offset: 0,
          limit: rowsPerPage,
          federation_id: currentFederation?.federation_id,
          query_id: queryIdFromUrl || path_queryId,
          event: filterEventType,
          user_name: filterUser,
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          role: userRole,
          start_date: FilterStartDate,
          end_date: FilterEndDate,
          fromOrganization: "true",
        });
      } catch (error) {
        if (error?.response?.status === 503) {
          setErrorMessage(
            "Service is temporarily unavailable. Please try again later.",
          );
        } else {
          setErrorMessage(
            "Something went wrong. Please refresh and try again.",
          );
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    const sideBarMenuToHighlight = mainMenuItems
      .flatMap((item) => item.subMenu)
      .find((subItem) =>
        subItem.urls.some((url) => url.includes("/provenance-record")),
      )?.label;

    setActiveSubItem(sideBarMenuToHighlight);
    setIsSideBarMenuDisabled({
      fed: false,
      cp: false,
      cr: false,
      pr: false,
      ah: false,
      ca: false,
      dm: false,
    });
    setBreadcrumbItems([
      { label: "Discover", path: "/entry-hub?console=Discover" },
      { label: "Curation", path: "/federation-selection" },
      { label: "Federation Selection", path: "/federation-selection" },
      {
        label: fedSpecificMenuLabels?.provenance_trail || "Provenance Record",
        path: "/provenance-record",
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       await getTrailFn.run();
  //     } catch (error) {
  //       if (error?.response?.status === 503) {
  //         setErrorMessage(
  //           "Service is temporarily unavailable. Please try again later."
  //         );
  //       } else {
  //         setErrorMessage(
  //           "Something went wrong. Please refresh and try again."
  //         );
  //       }
  //     }
  //   };

  //   fetchData();
  // }, []);

  const handleOpenModal = (row) => {
    setSelectedMetadata(row);
    setMetadataModalOpen(true);
  };
  const reloadTrails = () => {
    if (filter_start !== undefined && filter_end !== undefined) {
      setFilterStartDate(new Date(filter_start).getTime());
      setFilterEndDate(new Date(filter_end).getTime());
    }
    console.log({ filterOrg });
    setCurrentPage(1);
    setVisiblePages([1, 2, 3]);
    showTargetTab
      ? getTrailFnForTarget.run({
          promiseFn: getProvenanceTrail,
          offset: 0,
          limit: rowsPerPage,
          federation_id:
            currentFederation.federation_id ||
            localStorage.getItem("federationkey"),
          query_id: path_queryId || filterQueryId,
          event: filterEventType,
          user_name: filterUser,
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          role: userRole,
          start_date: FilterStartDate,
          end_date: FilterEndDate,
          fromOrganization: "false",
        })
      : getTrailFn.run({
          promiseFn: getProvenanceTrail,
          offset: 0,
          limit: rowsPerPage,
          federation_id:
            currentFederation.federation_id ||
            localStorage.getItem("federationkey"),
          start_date: FilterStartDate,
          end_date: FilterEndDate,
          event: filterEventType,
          query_id: filterQueryId,
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          role: userRole,
          user_name: filterUser,
          fromOrganization: "true",
        });
  };
  const resetFilterState = () => {
    setFilterStart(undefined);
    setFilterEnd(undefined);
    setFilterStartDate(undefined);
    setFilterEndDate(undefined);
    setFilterValue({});
    setFilterApplied(false);
    setFilterQueryId("");
    setFilterEventType(undefined);
    setFilterOrg(undefined);
    setFilterOrgId(undefined);
    setFilterUser(undefined);
    setEventName(undefined);
    setfilter_query(undefined);
    setCurrentPage(1);
    params.id = undefined;
  };

  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedTableData = useMemo(() => {
    if (!tableData?.length || !sortColumn) return tableData;
    return [...tableData].sort((a: any, b: any) => {
      if (sortColumn === "audienceSize") {
        const va = Number(a.event_type === "query" ? a.total_dp_count : (a.count !== "" ? a.count : a.total_dp_count)) || 0;
        const vb = Number(b.event_type === "query" ? b.total_dp_count : (b.count !== "" ? b.count : b.total_dp_count)) || 0;
        return sortDirection === "asc" ? va - vb : vb - va;
      }
      if (sortColumn === "timestamp") {
        const va = new Date(a.timestamp).getTime() || 0;
        const vb = new Date(b.timestamp).getTime() || 0;
        return sortDirection === "asc" ? va - vb : vb - va;
      }
      return 0;
    });
  }, [tableData, sortColumn, sortDirection]);

  const ClearFilters = () => {
    setFilterStart(undefined);
    setFilterEnd(undefined);
    setFilterStartDate(undefined);
    setFilterEndDate(undefined);
    setFilterValue({});
    setFilterApplied(false);
    setFilterQueryId("");
    setFilterEventType(undefined);
    setFilterOrg(undefined);
    setFilterOrgId(undefined);
    setFilterUser(undefined);
    setEventName(undefined);
    setfilter_query(undefined);
    setCurrentPage(1);
    params.id = undefined;
    setSortColumn(null);
    setSortDirection("asc");

    if (showTargetTab) {
      getTrailFnForTarget.run({
        promiseFn: getProvenanceTrail,
        offset: 0,
        limit: rowsPerPage,
        federation_id:
          currentFederation.federation_id ||
          localStorage.getItem("federationkey"),
        query_id: undefined,
        event: undefined,
        user_name: undefined,
        filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
        organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
        role: userRole,
        fromOrganization: "false",
      });
    } else {
      getTrailFn.run({
        promiseFn: getProvenanceTrail,
        offset: 0,
        limit: rowsPerPage,
        federation_id:
          currentFederation.federation_id ||
          localStorage.getItem("federationkey"),
        query_id: undefined,
        event: undefined,
        user_name: undefined,
        filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
        organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
        role: userRole,
        fromOrganization: "true",
      });
    }
  };

  useEffect(() => {
    if (!filterEffectMounted.current) {
      filterEffectMounted.current = true;
      return;
    }
    if (isTabSwitching.current) {
      return;
    }
    reloadTrails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    FilterStartDate,
    FilterEndDate,
    filterQueryId,
    filterEventType,
    filterOrgId,
    filterUser,
  ]);

  const removeFilter = (key: string) => {
    const updated = { ...filterValue };
    delete updated[key];
    setFilterValue(updated);
    if (Object.keys(updated).length === 0) setFilterApplied(false);

    if (key === "Query ID") {
      setfilter_query(undefined);
      setFilterQueryId("");
    } else if (key === "Event Type") {
      setFilterEventType(undefined);
      setEventName(undefined);
    } else if (key === "Organization") {
      setFilterOrg(undefined);
      setOrgName(undefined);
      setFilterOrgId(undefined);
    } else if (key === "User") {
      setFilterUser(undefined);
    } else if (key === "Timestamp") {
      setFilterStart(undefined);
      setFilterEnd(undefined);
      setFilterStartDate(undefined);
      setFilterEndDate(undefined);
    } else if (key === "Start Date") {
      setFilterStart(undefined);
      setFilterStartDate(undefined);
    } else if (key === "End Date") {
      setFilterEnd(undefined);
      setFilterEndDate(undefined);
    }
  };

  const HandleUserOrQueryFilter = (value) => {
    setFilterApplied(true);
    const isQueryId = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(
      value,
    );
    const tempFilterVal = { ...filterValue };
    delete tempFilterVal["Query ID"];
    delete tempFilterVal["User"];
    if (isQueryId) {
      setFilterQueryId(value);
      setfilter_query(undefined);
      setFilterUser(undefined);
      setFilterValue({ ...tempFilterVal, "Query ID": value });
    } else {
      setFilterUser(value);
      setFilterQueryId("");
      setfilter_query(undefined);
      setFilterValue({ ...tempFilterVal, User: value });
    }
  };
  const getSelectedParticipant = (value) => {
    const selectedOrgId = allOrgs.find(
      (item) => item.organization_name === value,
    )?.organization_id;
    setFilterApplied(true);
    setFilterOrg(value);
    setFilterOrgId(selectedOrgId);
    setFilterValue({ ...filterValue, Organization: value });
    setCurrentPage(1);
    setVisiblePages([1, 2, 3]);
  };
  const getSelectedEventType = (value) => {
    const resolvedEventValue = allProvenanceEvents?.find(
      (item) => item.label === value,
    )?.value;
    setFilterApplied(true);
    setFilterEventType(resolvedEventValue);
    setFilterValue({ ...filterValue, "Event Type": value });
  };

  useEffect(() => {
    const tableContainer = document.querySelector(
      `.${styles.container}`,
    ) as HTMLElement;
    if (tableContainer) {
      tableContainer.style.minHeight =
        openEventTypeDropdown || openParticipantsDropdown ? "300px" : "";
    }
  }, [openEventTypeDropdown, openParticipantsDropdown]);

  const HandleTimestamp = (startDate, endDate) => {
    setFilterApplied(true);
    setFilterStartDate(new Date(startDate).getTime());
    setFilterEndDate(new Date(endDate).getTime());
    setFilterValue({
      ...filterValue,
      Timestamp: `From ${startDate} to ${endDate}`,
    });
  };

  const formatEventType = (eventType: string): string => {
    const normalized = eventType.replace(/_/g, " ").trim().toLowerCase();
    if (
      normalized === "marked" ||
      normalized === "engaged" ||
      normalized === "marked engaged"
    ) {
      return "Engaged";
    }
    return eventType
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };


  // const handlePageClick = async (page) => {
  //   if (page === visiblePages[visiblePages.length - 1] && page < 10) {
  //     setVisiblePages([...visiblePages, page + 1]);
  //   } else if (page === visiblePages[0] && page > 1) {
  //     setVisiblePages([page - 1, ...visiblePages]);
  //   }
  //   const response = await getTrailFn.run({
  //     promiseFn: getProvenanceTrail,
  //     offset: calculateOffset(page, 10),
  //     limit: rowsPerPage,
  //     federation_id: sessionFederationId,
  //     organization_id: filterOrg,
  //     event: filterEventType,
  //     query_id: filterQueryId,
  //   });
  //   setCurrentPage(page);
  //   if (response?.activities) {
  //     setTableData(response.activities);
  //   }
  // };

  const handlePreviousPageClick = async () => {
    if (currentPage === 1) {
      showToast("You are already on the first page.", "info");
      return;
    }
    setPaginationInProgress(true);
    if (
      currentPage - 1 === visiblePages[visiblePages.length - 1] &&
      currentPage < 10
    ) {
      setVisiblePages([...visiblePages, currentPage + 1]);
    } else if (currentPage - 1 === visiblePages[0] && currentPage - 1 > 1) {
      setVisiblePages([currentPage - 2, ...visiblePages]);
    }
    showTargetTab
      ? await getTrailFnForTarget.run({
          promiseFn: getProvenanceTrail,
          offset: calculateOffset(currentPage - 1, rowsPerPage),
          limit: rowsPerPage,
          federation_id:
            currentFederation.federation_id ||
            localStorage.getItem("federationkey"),
          query_id: path_queryId || filterQueryId,
          event: filterEventType,
          user_name: filterUser,
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          role: userRole,
          fromOrganization: "false",
          start_date: FilterStartDate,
          end_date: FilterEndDate,
        })
      : await getTrailFn.run({
          promiseFn: getProvenanceTrail,
          offset: calculateOffset(currentPage - 1, rowsPerPage),
          limit: rowsPerPage,
          federation_id:
            currentFederation.federation_id ||
            localStorage.getItem("federationkey"),
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          event: filterEventType,
          query_id: filterQueryId,
          role: userRole,
          user_name: filterUser,
          start_date: FilterStartDate,
          end_date: FilterEndDate,
          fromOrganization: "true",
        });
    setCurrentPage(currentPage - 1);
  };

  const handleNextPageClick = async () => {
    if (!tableData?.length || currentPage >= totalPages) {
      showToast("No more data to display.", "info");
      return;
    }
    setPaginationInProgress(true);
    if (
      currentPage + 1 === visiblePages[visiblePages.length - 1] &&
      currentPage < 10
    ) {
      setVisiblePages([...visiblePages, currentPage + 2]);
    } else if (currentPage === visiblePages[0] && currentPage > 1) {
      setVisiblePages([currentPage - 1, ...visiblePages]);
    }
    showTargetTab
      ? await getTrailFnForTarget.run({
          promiseFn: getProvenanceTrail,
          offset: calculateOffset(currentPage + 1, rowsPerPage),
          limit: rowsPerPage,
          federation_id:
            currentFederation.federation_id ||
            localStorage.getItem("federationkey"),
          query_id: path_queryId || filterQueryId,
          event: filterEventType,
          user_name: filterUser,
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          role: userRole,
          fromOrganization: "false",
          start_date: FilterStartDate,
          end_date: FilterEndDate,
        })
      : await getTrailFn.run({
          promiseFn: getProvenanceTrail,
          offset: calculateOffset(currentPage + 1, rowsPerPage),
          limit: rowsPerPage,
          federation_id:
            currentFederation.federation_id ||
            localStorage.getItem("federationkey"),
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          event: filterEventType,
          query_id: filterQueryId,
          role: userRole,
          user_name: filterUser,
          start_date: FilterStartDate,
          end_date: FilterEndDate,
          fromOrganization: "true",
        });
    setCurrentPage(currentPage + 1);
  };
  console.log({ sessionOrgId });
  const reloadRecords = async (limit = rowsPerPage) => {
    setLoading(true);
    try {
      showTargetTab
        ? await getTrailFnForTarget.run({
            promiseFn: getProvenanceTrail,
            offset: 0,
            limit,
            federation_id:
              currentFederation.federation_id ||
              localStorage.getItem("federationkey"),
            query_id: path_queryId || filterQueryId,
            event: filterEventType,
            user_name: filterUser,
            filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
            organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
            role: userRole,
            fromOrganization: "false",
            start_date: FilterStartDate,
            end_date: FilterEndDate,
          })
        : await getTrailFn.run({
            promiseFn: getProvenanceTrail,
            offset: 0,
            limit,
            federation_id:
              currentFederation.federation_id ||
              localStorage.getItem("federationkey"),
            start_date: FilterStartDate,
            end_date: FilterEndDate,
            event: filterEventType,
            query_id: filterQueryId,
            filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
            organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
            role: userRole,
            user_name: filterUser,
            fromOrganization: "true",
          });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  const calculateOffset = (page, pageSize = 8): number => {
    return (page - 1) * pageSize;
  };

  // Returns page numbers with null representing an ellipsis gap
  const getVisiblePageNumbers = (
    current: number,
    total: number,
  ): (number | null)[] => {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    if (current <= 4) return [1, 2, 3, 4, 5, null, total];
    if (current >= total - 3)
      return [1, null, total - 4, total - 3, total - 2, total - 1, total];
    return [1, null, current - 1, current, current + 1, null, total];
  };

  const handlePageClick = async (page: number) => {
    if (page === currentPage) return;
    setPaginationInProgress(true);
    showTargetTab
      ? await getTrailFnForTarget.run({
          promiseFn: getProvenanceTrail,
          offset: calculateOffset(page, rowsPerPage),
          limit: rowsPerPage,
          federation_id:
            currentFederation.federation_id ||
            localStorage.getItem("federationkey"),
          query_id: path_queryId || filterQueryId,
          event: filterEventType,
          user_name: filterUser,
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          role: userRole,
          fromOrganization: "false",
          start_date: FilterStartDate,
          end_date: FilterEndDate,
        })
      : await getTrailFn.run({
          promiseFn: getProvenanceTrail,
          offset: calculateOffset(page, rowsPerPage),
          limit: rowsPerPage,
          federation_id:
            currentFederation.federation_id ||
            localStorage.getItem("federationkey"),
          filterOrgId: isPlatformOrAppAdmin ? filterOrgId : (filterOrgId ?? sessionOrgId),
          organization_id: isPlatformOrAppAdmin ? undefined : sessionOrgId,
          event: filterEventType,
          query_id: filterQueryId,
          role: userRole,
          user_name: filterUser,
          start_date: FilterStartDate,
          end_date: FilterEndDate,
          fromOrganization: "true",
        });
    setCurrentPage(page);
  };
  const targetIsEmpty =
    !showTargetTab &&
    getTrailFnForTarget.data !== undefined &&
    !getTrailFnForTarget.data?.activities?.length;

  const isFetching = showTargetTab
    ? getTrailFnForTarget.isPending
    : getTrailFn.isPending;

  // Wait until initiated is loaded, and if it's empty wait for target auto-switch fetch
  const readyForEmptyState =
    getTrailFn.data !== undefined &&
    (!!getTrailFn.data?.activities?.length ||
      getTrailFnForTarget.data !== undefined);

  const showNoRecordsState =
    (!tableData?.length &&
      !Object.keys(filterValue).length &&
      !loading &&
      !isFetching &&
      !paginationInProgress &&
      readyForEmptyState) ||
    !!errorMessage;

  useEffect(() => {
    if (isFetching) {
      clearTimeout(shimmerTimerRef.current);
      setShimmerVisible(true);
    } else {
      shimmerTimerRef.current = setTimeout(() => setShimmerVisible(false), 500);
    }
    return () => clearTimeout(shimmerTimerRef.current);
  }, [isFetching]);

  const storedPermissions = JSON.parse(
    localStorage.getItem("userPermissions") || "{}",
  );
  return storedPermissions?.provenancetrail === "no" ? (
    <PageNotFound />
  ) : (
    <LayoutContainer>
      <div className={styles.provenanceContainer}>
        <div className={styles.actionsBar}>
          <button
            className={styles.backButton}
            onClick={() => window?.history?.back()}
          >
            <img src={SimpleBackIcon} alt="back" />
            <span className={styles.backButtonText}>Back</span>
          </button>
          <div className={styles.switchOptions}>
            <div>
              <span className={styles.switchFederation}>
                Switch Federation:
              </span>
              <SearchableDropdown<{ federation_id: string; name: string }>
                fetchOptions={async (name, cursor) => {
                  if (isPlatformOrAppAdmin) {
                    const result = await getFederations({
                      args: { name, page_size: 8, cursor },
                    });
                    return {
                      items: (result?.items ?? []).map((f: any) => ({
                        ...f,
                        federation_id: f.id,
                      })),
                      pagination: result?.pagination,
                    };
                  }
                  return getLogoFederationID({
                    args: {
                      organizationID: organizationId,
                      name,
                      page_size: 8,
                      cursor,
                    },
                  });
                }}
                onSelect={(fed) => {
                  handleSelectFederation(fed);
                  setFederationToggled(true);
                }}
                onClear={() => {}}
                getLabel={(fed) => fed.name}
                getValue={(fed) => fed.federation_id}
                selectedValue={currentFederation?.federation_id || ""}
                selectedLabel={currentFederation?.name || ""}
                placeholder="Search federation…"
                className={styles.select}
              />
            </div>
            <InforIcon
              className={styles.switchIcon}
              onClick={() => setShowInfoPopup(true)}
            />
            {showInfoPopup && (
              <InfoPopup
                isOpen={showInfoPopup}
                onClose={() => setShowInfoPopup(false)}
                closeButtonLabel="Got it"
                headerText="Information"
              >
                <p className={styles.infoIntro}>
                  Federation-wide provenance report capturing the audit trail of each action in the selected federation.
                  The <strong>Initiated</strong> tab shows records where your organisation initiated the query;
                  the <strong>Target</strong> tab shows records where your organisation was queried.
                </p>
                <table className={styles.infoTable}>
                  <thead>
                    <tr>
                      <th>Event Type</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { type: "Query", desc: "Query was successfully executed." },
                      { type: "Audience Generated", desc: "Successful completion of transferring query results from FQS to designated end points." },
                      { type: "Audience Transferred", desc: "Completion of transfer of query results from FQS to designated endpoints." },
                      { type: "Engaged", desc: "Query results are marked for engagement; transfer will be initiated subsequently." },
                      { type: "Deleted", desc: "Data deletion was successful." },
                    ].map(({ type, desc }) => (
                      <tr key={type}>
                        <td>{type}</td>
                        <td>{desc}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </InfoPopup>
            )}
          </div>
        </div>

        {showNoRecordsState ? (
          <NoData
            {...(failureMessage || errorMessage
              ? { message: failureMessage || errorMessage }
              : {})}
          />
        ) : (
        <>
        <div
          className={styles.container}
          style={
            {
              "--initiated-tab-bg-color": showTargetTab
                ? "var(--pr-surface)"
                : "var(--pr-tab-active-bg)",
              "--target-tab-bg-color": showTargetTab
                ? "var(--pr-tab-active-bg)"
                : "var(--pr-surface)",
              "--initiated-active-border": showTargetTab
                ? "transparent"
                : "var(--Primary-Color-Shade-1, #0d6ab3)",
              "--target-active-border": showTargetTab
                ? "var(--Primary-Color-Shade-1, #0d6ab3)"
                : "transparent",
            } as React.CSSProperties
          }
        >
          <div className={styles.tableControls}>
            <div className={styles.tabContainer}>
              <div
                className={styles.initiated}
                onClick={() => {
                  isTabSwitching.current = true;
                  resetFilterState();
                  setTimeout(() => {
                    isTabSwitching.current = false;
                  }, 0);
                  setShowTargetTab(false);
                  setFilterApplied(true);
                  getTrailFn.run({
                    promiseFn: getProvenanceTrail,
                    limit: rowsPerPage,
                    scan_index_forward: false,
                    federation_id:
                      currentFederation.federation_id ||
                      localStorage.getItem("federationkey"),
                    filterOrgId: isPlatformOrAppAdmin
                      ? filterOrgId
                      : sessionOrgId,
                    organization_id: isPlatformOrAppAdmin
                      ? undefined
                      : sessionOrgId,
                    target: false,
                    role: userRole,
                    fromOrganization: "true",
                  });
                }}
              >
                Initiated
              </div>

              <Tooltip
                text={targetIsEmpty ? "No target records for this federation" : ""}
                placement="top"
                style={{ alignItems: "stretch" }}
              >
                <div
                  className={styles.target}
                  style={targetIsEmpty ? { opacity: 0.45, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  onClick={() => {
                    if (targetIsEmpty) return;
                    isTabSwitching.current = true;
                    resetFilterState();
                    setTimeout(() => {
                      isTabSwitching.current = false;
                    }, 0);
                    setShowTargetTab(true);
                    getTrailFnForTarget.run({
                      promiseFn: getProvenanceTrail,
                      limit: rowsPerPage,
                      scan_index_forward: false,
                      federation_id:
                        currentFederation.federation_id ||
                        localStorage.getItem("federationkey"),
                      filterOrgId: isPlatformOrAppAdmin
                        ? filterOrgId
                        : sessionOrgId,
                      organization_id: isPlatformOrAppAdmin
                        ? undefined
                        : sessionOrgId,
                      target: false,
                      role: userRole,
                      fromOrganization: "false",
                    });
                    setFilterApplied(true);
                  }}
                >
                  Target
                </div>
              </Tooltip>

              {Object.keys(filterValue).length > 0 && (
                <div className={styles.filterChips}>
                  {Object.entries(filterValue).map(([key, val]) => (
                    <span key={key} className={styles.filterChip}>
                      <strong>{key}:</strong>&nbsp;{val as string}
                      <button
                        type="button"
                        className={styles.filterChipRemove}
                        onClick={() => removeFilter(key)}
                        aria-label={`Remove ${key} filter`}
                      >
                        {(FEATURES.curationSkin ? <OI n="close" size="1em" /> : "✕")}
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div className={styles.filtersContainer}>
              <DownloadButton
                element_color="var(--Primary-Color-Shade-1)"
                downloadCSV={downloadCSV}
                downloadJSON={() => {}}
                downloadPDF={downloadPDF}
                showJson={false}
              />

              <span className={styles.clearFilters} onClick={ClearFilters}>
                Clear Filters
              </span>
              <span className={styles.reload} onClick={() => reloadRecords()}>
                Reload
              </span>
              <ColumnVisibilityToggle
                columns={PR_COLUMNS}
                hidden={hiddenCols}
                onChange={toggleCol}
              />
            </div>
          </div>
          <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th></th>
                    {col("user") && (
                      <th
                        style={{ width: columnWidths[1], position: "relative" }}
                      >
                        <ColHeader
                          label="User | Query ID"
                          icon={<MdPerson />}
                          actionsAlign="right"
                        >
                          <FilterIcon
                            className={styles.icon}
                            onClick={() => setOpenUserSearchModal(true)}
                          />
                        </ColHeader>
                        {openUserSearchModal && (
                          <SearchModal
                            isOpen={openUserSearchModal}
                            onClose={() => setOpenUserSearchModal(false)}
                            onApply={HandleUserOrQueryFilter}
                            headerText="Search User or Query ID"
                            placeholder="User Name or Query ID"
                            errorText="Please enter User Name or Query ID"
                          />
                        )}
                        <div
                          className={styles.resizeHandle}
                          onMouseDown={(e) => handleMouseDown(e, 1)}
                        />
                      </th>
                    )}
                    {col("organizations") && (
                      <th
                        style={{ width: columnWidths[2], position: "relative" }}
                      >
                        <ColHeader label="Organizations" icon={<MdBusiness />}>
                          {!isOrgAdmin && (
                            <>
                              <DownIcon
                                className={styles.icon}
                                onClick={() =>
                                  setOpenParticipantsDropdown(true)
                                }
                              />
                              {openParticipantsDropdown && (
                                <Dropdown
                                  items={allOrgs?.map(
                                    (item) => item.organization_name,
                                  )}
                                  onSelect={getSelectedParticipant}
                                  isOpen={openParticipantsDropdown}
                                  onClose={() =>
                                    setOpenParticipantsDropdown(false)
                                  }
                                />
                              )}
                            </>
                          )}
                        </ColHeader>
                        <div
                          className={styles.resizeHandle}
                          onMouseDown={(e) => handleMouseDown(e, 2)}
                        />
                      </th>
                    )}
                    {col("eventType") && (
                      <th
                        style={{ width: columnWidths[3], position: "relative" }}
                      >
                        <ColHeader label="Event Type" icon={<MdFlashOn />}>
                          <DownIcon
                            className={styles.icon}
                            onClick={() => setOpenEventTypeDropdown(true)}
                          />
                        </ColHeader>
                        {openEventTypeDropdown && (
                          <Dropdown
                            items={allProvenanceEvents?.map(
                              (item) => item.label,
                            )}
                            onSelect={getSelectedEventType}
                            isOpen={openEventTypeDropdown}
                            onClose={() => setOpenEventTypeDropdown(false)}
                          />
                        )}
                        <div
                          className={styles.resizeHandle}
                          onMouseDown={(e) => handleMouseDown(e, 3)}
                        />
                      </th>
                    )}
                    {col("count") && (
                      <th
                        style={{ width: columnWidths[4], position: "relative" }}
                      >
                        <ColHeader label="Audience Size" icon={<MdNumbers />}>
                          <button
                            className={styles.sortBtn}
                            onClick={() => handleSort("audienceSize")}
                            aria-label={`Sort by audience size ${sortColumn === "audienceSize" ? (sortDirection === "asc" ? "descending" : "ascending") : "ascending"}`}
                          >
                            {sortColumn === "audienceSize" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                          </button>
                        </ColHeader>
                        <div
                          className={styles.resizeHandle}
                          onMouseDown={(e) => handleMouseDown(e, 4)}
                        />
                      </th>
                    )}
                    {col("metadata") && (
                      <th
                        style={{ width: columnWidths[5], position: "relative" }}
                      >
                        <ColHeader label="Meta Data" icon={<MdInfoOutline />} />
                        <div
                          className={styles.resizeHandle}
                          onMouseDown={(e) => handleMouseDown(e, 5)}
                        />
                      </th>
                    )}
                    {col("timestamp") && (
                      <th
                        style={{ width: columnWidths[6], position: "relative" }}
                      >
                        <ColHeader
                          label="Timestamp"
                          icon={<MdCalendarToday />}
                          actionsAlign="right"
                        >
                          <button
                            className={styles.sortBtn}
                            onClick={() => handleSort("timestamp")}
                            aria-label={`Sort by timestamp ${sortColumn === "timestamp" ? (sortDirection === "asc" ? "descending" : "ascending") : "ascending"}`}
                          >
                            {sortColumn === "timestamp" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                          </button>
                          <FilterIcon
                            className={styles.icon}
                            onClick={() => setDatePickerOpen(true)}
                          />
                        </ColHeader>
                        {datePickerOpen && (
                          <DatePickerModal
                            datePickerOpen={datePickerOpen}
                            onClose={() => setDatePickerOpen(false)}
                            onApply={HandleTimestamp}
                          />
                        )}
                        <div
                          className={styles.resizeHandle}
                          onMouseDown={(e) => handleMouseDown(e, 6)}
                        />
                      </th>
                    )}
                    {/* Optional metadata columns */}
                    {col("meta_campaign") && (
                      <th style={{ width: columnWidths[7], position: "relative" }}>
                        <ColHeader label="Cohort Name" icon={<MdInfoOutline />} />
                        <div className={styles.resizeHandle} onMouseDown={(e) => handleMouseDown(e, 7)} />
                      </th>
                    )}
                    {col("meta_id_type") && (
                      <th style={{ width: columnWidths[8], position: "relative" }}>
                        <ColHeader label="ID Type" icon={<MdInfoOutline />} />
                        <div className={styles.resizeHandle} onMouseDown={(e) => handleMouseDown(e, 8)} />
                      </th>
                    )}
                    {col("meta_objective") && (
                      <th style={{ width: columnWidths[9], position: "relative" }}>
                        <ColHeader label="Query Objective" icon={<MdInfoOutline />} />
                        <div className={styles.resizeHandle} onMouseDown={(e) => handleMouseDown(e, 9)} />
                      </th>
                    )}
                    {col("meta_expiry") && (
                      <th style={{ width: columnWidths[10], position: "relative" }}>
                        <ColHeader label="Expiry" icon={<MdInfoOutline />} />
                        <div className={styles.resizeHandle} onMouseDown={(e) => handleMouseDown(e, 10)} />
                      </th>
                    )}
                    {col("meta_content") && (
                      <th style={{ width: columnWidths[11], position: "relative" }}>
                        <ColHeader label="Content" icon={<MdInfoOutline />} />
                        <div className={styles.resizeHandle} onMouseDown={(e) => handleMouseDown(e, 11)} />
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {loading || shimmerVisible ? (
                    Array.from({ length: rowsPerPage }).map((_, i) => (
                      <ShimmerRow key={i} />
                    ))
                  ) : (
                    <>
                      {!tableData?.length &&
                        (paginationInProgress ||
                          (filterApplied && !loading)) && (
                          <tr>
                            <td colSpan={7} className={styles.centeredCell}>
                              No records match your active filters.{" "}
                              <span
                                style={{ color: "var(--Primary-Color-Shade-1, #0d6ab3)", cursor: "pointer", textDecoration: "underline" }}
                                onClick={ClearFilters}
                              >
                                Clear filters
                              </span>{" "}
                              to see all records.
                            </td>
                          </tr>
                        )}
                      {sortedTableData?.map((row, index) => (
                        <React.Fragment key={row.query_id}>
                          <tr
                            key={row.query_id}
                            className={
                              expandedRows[index] ? styles.expanded : ""
                            }
                          >
                            <td
                              className={styles.expandableRow}
                              onClick={() => toggleRow(index)}
                            >
                              <span
                                className={`${styles.expandIcon} ${
                                  expandedRows[index] ? styles.expandedIcon : ""
                                }`}
                              >
                                {row.query_result_set?.length > 0 &&
                                  (expandedRows[index] ? (
                                    <DownIcon className={styles.downIcon} />
                                  ) : (
                                    <DownIcon />
                                  ))}
                              </span>
                            </td>
                            {col("user") && (
                              <td className={styles.queryCell}>
                                <div className={styles.userQueryCell}>
                                  <Tooltip text={row.user} placement="top">
                                    <span className={styles.userNameText}>
                                      {row.user_name}
                                    </span>
                                  </Tooltip>
                                  <div className={styles.queryIdRow}>
                                    <span className={styles.queryIdText}>
                                      {row.query_id}
                                    </span>
                                    <Tooltip
                                      text={
                                        copiedQueryId === row.query_id
                                          ? "Copied!"
                                          : "Copy"
                                      }
                                      placement="top"
                                    >
                                      <button
                                        className={styles.queryIdCopyBtn}
                                        onClick={() => {
                                          copyToClipboard(row.query_id);
                                          setCopiedQueryId(row.query_id);
                                          setTimeout(
                                            () => setCopiedQueryId(null),
                                            1000,
                                          );
                                        }}
                                      >
                                        <CopyIcon className={styles.copyIcon} />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </div>
                              </td>
                            )}
                            {col("organizations") && (
                              <td>{row.organization_name}</td>
                            )}
                            {col("eventType") && (
                              <td>{formatEventType(row.event_type)}</td>
                            )}
                            {col("count") && (
                              <td>
                                {Number(
                                  row.event_type === "query"
                                    ? row.total_dp_count
                                    : row.count !== "" ? row.count : row.total_dp_count,
                                ).toLocaleString("en-US")}
                              </td>
                            )}
                            {col("metadata") && (
                              <td>
                                <Tooltip text="View metadata" placement="top">
                                  <MetadataIcon
                                    className={styles.metadataIcon}
                                    onClick={() => handleOpenModal(row)}
                                  />
                                </Tooltip>
                                {metadataModalOpen && selectedMetadata && (
                                  <MetadataModal
                                    isOpen={metadataModalOpen}
                                    onClose={() => setMetadataModalOpen(false)}
                                    metadataObj={selectedMetadata}
                                    identityTypeMap={identityTypeMap}
                                  />
                                )}
                              </td>
                            )}
                            {col("timestamp") && (
                              <td>
                                {(() => {
                                  const parts = formatDateTimeParts(row.timestamp);
                                  if (!parts) return <span>—</span>;
                                  return (
                                    <div className={styles.dateTimeCell}>
                                      <span className={styles.dateText}>
                                        {parts.date}
                                      </span>
                                      <span className={styles.timeText}>
                                        {parts.time}
                                      </span>
                                    </div>
                                  );
                                })()}
                              </td>
                            )}
                            {col("meta_campaign") && <td>{row.campaign_name || "—"}</td>}
                            {col("meta_id_type") && <td>{identityTypeMap?.get(row.metadata?.identifier) ?? row.metadata?.identifier ?? "—"}</td>}
                            {col("meta_objective") && <td>{row.metadata?.query_objective ? capitalize(row.metadata.query_objective) : "—"}</td>}
                            {col("meta_expiry") && <td>{row.metadata?.expiry_duration ? (isNaN(Date.parse(row.metadata.expiry_duration)) ? row.metadata.expiry_duration : formatDateTime(row.metadata.expiry_duration)) : "—"}</td>}
                            {col("meta_content") && <td>{identityTypeMap?.get(row.metadata?.content) ?? row.metadata?.content ?? "—"}</td>}
                          </tr>
                          {expandedRows[index] && (
                            <>
                              {row.query_result_set?.map((result, idx) => {
                                return (
                                  <tr
                                    key={result.subquery_id}
                                    className={`${styles.expandedRow} ${
                                      expandedRows[index] ? "active" : ""
                                    } ${styles.expandedContent}`}
                                  >
                                    <td
                                      className={`${styles.expandableRow} ${styles.verticalLine}`}
                                    ></td>
                                    {col("user") && <td>{row.user_name}</td>}
                                    {col("organizations") && (
                                      <td>
                                        {result.contributor_organisation_name}
                                      </td>
                                    )}
                                    {col("eventType") && (
                                      <td>
                                        {formatEventType(row.event_type)}
                                      </td>
                                    )}
                                    {col("count") && (
                                      <td>
                                        {Number(
                                          result.count !== "" ? result.count : result.dp_count,
                                        ).toLocaleString("en-US")}
                                      </td>
                                    )}
                                    {col("metadata") && (
                                      <td>
                                        <Tooltip text="View metadata" placement="top">
                                          <MetadataIcon
                                            className={styles.metadataIcon}
                                            onClick={() => handleOpenModal(result)}
                                          />
                                        </Tooltip>
                                      </td>
                                    )}
                                    {col("timestamp") && (
                                      <td>
                                        {(() => {
                                          const parts = formatDateTimeParts(result.timestamp);
                                          if (!parts) return <span>—</span>;
                                          return (
                                            <div
                                              className={styles.dateTimeCell}
                                            >
                                              <span className={styles.dateText}>
                                                {parts.date}
                                              </span>
                                              <span className={styles.timeText}>
                                                {parts.time}
                                              </span>
                                            </div>
                                          );
                                        })()}
                                      </td>
                                    )}
                                    {col("meta_campaign") && <td>{result.campaign_name || "—"}</td>}
                                    {col("meta_id_type") && <td>{identityTypeMap?.get(result.metadata?.identifier) ?? result.metadata?.identifier ?? "—"}</td>}
                                    {col("meta_objective") && <td>{result.metadata?.query_objective ? capitalize(result.metadata.query_objective) : "—"}</td>}
                                    {col("meta_expiry") && <td>{result.metadata?.expiry_duration ? (isNaN(Date.parse(result.metadata.expiry_duration)) ? result.metadata.expiry_duration : formatDateTime(result.metadata.expiry_duration)) : "—"}</td>}
                                    {col("meta_content") && <td>{identityTypeMap?.get(result.metadata?.content) ?? result.metadata?.content ?? "—"}</td>}
                                  </tr>
                                );
                              })}
                            </>
                          )}
                        </React.Fragment>
                      ))}
                    </>
                  )}
                </tbody>
              </table>
          </div>
        </div>
        <div className={styles.tableFooter}>
          {totalCount > 0 ? (
            <span className={styles.recordCount}>
              Showing{" "}
              <strong>
                {((currentPage - 1) * rowsPerPage + 1).toLocaleString()}–
                {Math.min(
                  currentPage * rowsPerPage,
                  totalCount,
                ).toLocaleString()}
              </strong>{" "}
              of <strong>{totalCount.toLocaleString()}</strong> records
              <select
                className={styles.rowsPerPageSelect}
                value={rowsPerPage}
                onChange={(e) => {
                  const size = Number(e.target.value);
                  setRowsPerPage(size);
                  setCurrentPage(1);
                  reloadRecords(size);
                }}
                aria-label="Rows per page"
              >
                {[8, 25, 50].map((n) => (
                  <option key={n} value={n}>{n} / page</option>
                ))}
              </select>
            </span>
          ) : (
            <span />
          )}
          {totalCount > 0 && (
            <div className={styles.paginationControls}>
              <button
                className={
                  currentPage === 1 ? styles.navigationDisable : styles.prevPage
                }
                onClick={handlePreviousPageClick}
              >
                ‹ Previous
              </button>
              <div className={styles.pageNumbers}>
                {getVisiblePageNumbers(currentPage, totalPages).map(
                  (page, i) =>
                    page === null ? (
                      <span
                        key={`ellipsis-${i}`}
                        className={styles.pageEllipsis}
                      >
                        …
                      </span>
                    ) : (
                      <button
                        key={page}
                        className={
                          page === currentPage
                            ? styles.activePage
                            : styles.pageNumber
                        }
                        onClick={() => handlePageClick(page)}
                      >
                        {page}
                      </button>
                    ),
                )}
              </div>
              <button
                className={
                  currentPage >= totalPages
                    ? styles.navigationDisable
                    : styles.nextPage
                }
                onClick={handleNextPageClick}
              >
                Next ›
              </button>
            </div>
          )}
        </div>
        </>
        )}
      </div>
    </LayoutContainer>
  );
};
export default ProvenanceRecord;
